import React from 'react'
import { Badge } from '@tecsinapse/cortex-react'
import { t } from '@lingui/core/macro'
import { isNewItem } from '../utils/functions'

export const NewItemBadge = ({ dataCriacao }: { dataCriacao: Date }) => {
  if (!isNewItem(new Date(dataCriacao))) return null
  return <Badge color='primary' value={t`Novo`} />
}
